var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-modal",class:`${_vm.isModalOpen ? 'open' : 'closed'}`},[(_vm.isModalOpen)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }